import { Compass } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const CompassIcon = createLucideIcon(Compass);
